import { render, staticRenderFns } from "./DossiersFactures.vue?vue&type=template&id=fdcaaa84&scoped=true&"
import script from "./DossiersFactures.vue?vue&type=script&lang=js&"
export * from "./DossiersFactures.vue?vue&type=script&lang=js&"
import style0 from "./DossiersFactures.vue?vue&type=style&index=0&id=fdcaaa84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcaaa84",
  null
  
)

export default component.exports